export default "__VITE_ASSET__nzsZKy8w__"